export default __webpack_public_path__ + "static/about-me-9d9bd7a5d5021729b45b2577b6149478.png";